// YouTube URL helpers. Accepts watch / youtu.be / shorts / embed forms.

// Extract the 11-char video id, or null when the input isn't a YouTube link.
export function youtubeId(url) {
  if (!url) return null;
  const s = String(url).trim();
  const patterns = [
    /youtube\.com\/watch\?v=([\w-]{11})/,
    /youtu\.be\/([\w-]{11})/,
    /youtube\.com\/shorts\/([\w-]{11})/,
    /youtube\.com\/embed\/([\w-]{11})/,
  ];
  for (const re of patterns) {
    const m = s.match(re);
    if (m) return m[1];
  }
  return null;
}

// Build an embeddable URL, or null when the input isn't a recognizable YouTube link.
export function toYoutubeEmbed(url) {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}

// Thumbnail image URL for a YouTube link, or null when not a YouTube link.
export function youtubeThumb(url) {
  const id = youtubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}

// True when url points at youtube.com / youtu.be (any path). Used to validate a
// channel link — a channel URL isn't an embeddable video, so youtubeId won't match.
export function isYoutubeUrl(url) {
  if (!url) return false;
  try {
    const u = new URL(String(url).trim());
    return /(^|\.)youtube\.com$/.test(u.hostname) || u.hostname === 'youtu.be';
  } catch {
    return false;
  }
}
